import { useState } from "react";
import { getTabData } from "../helpers";

const useTabData = ({
    isTeacherUser
}) => {
	const [tabData] = useState(getTabData(isTeacherUser));
    return tabData;
}	
    
export default useTabData;